import serviceDishApi from '@/api/service-dish'

const failure = error => error?.response?.data?.message || 'Не удалось выполнить — повторите позже'

const state = {
  list: [],
  loading: false,
  syncing: false,
  uploadingId: null,
  lastSync: null,
  error: null,
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    commit('SET_LOADING', true)

    return serviceDishApi.getAll()
      .then(({ data }) => commit('SET_LIST', data))
      .catch(error => commit('FAILED', failure(error)))
      .finally(() => commit('SET_LOADING', false))
  },
  sync({ commit, dispatch }) {
    commit('SET_SYNCING', true)
    commit('FAILED', null)

    return serviceDishApi.sync()
      .then(({ data }) => {
        commit('SYNCED', data)

        return dispatch('fetchList')
      })
      .catch(error => commit('FAILED', failure(error)))
      .finally(() => commit('SET_SYNCING', false))
  },
  uploadImage({ commit, dispatch }, { id, file }) {
    commit('SET_UPLOADING', id)
    commit('FAILED', null)

    return serviceDishApi.putImage(id, file)
      .then(() => dispatch('fetchList'))
      .catch(error => commit('FAILED', failure(error)))
      .finally(() => commit('SET_UPLOADING', null))
  },
}

const mutations = {
  SET_LIST(state, data) {
    state.list = data
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_SYNCING(state, value) {
    state.syncing = value
  },
  SET_UPLOADING(state, id) {
    state.uploadingId = id
  },
  SYNCED(state, result) {
    state.lastSync = result
  },
  FAILED(state, message) {
    state.error = message
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
